import { render, staticRenderFns } from "./ProductPeriodsChart.vue?vue&type=template&id=4f66c604&"
import script from "./ProductPeriodsChart.vue?vue&type=script&lang=js&"
export * from "./ProductPeriodsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports